import openModal from "../../util/openModal";

export const useRequireLogin = () => {
  const requireLogin = (event) => {
    if (event) {
      event.preventDefault();
    }

    openModal("#modalLogin");
  };

  return {
    requireLogin,
  };
};
